"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _root_model = _interopRequireDefault(require("./root_model"));
var _level = _interopRequireDefault(require("./level"));
var _lodash = require("lodash");
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
var _utils = require("@seedlang/utils");
var _language = _interopRequireDefault(require("./language"));
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var TargetLanguage = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_language["default"])), _dec3 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec4 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _class = /*#__PURE__*/function (_RootModel) {
  function TargetLanguage() {
    var _this;
    _classCallCheck(this, TargetLanguage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TargetLanguage, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor2, _this);
    _initializerDefineProperty(_this, "levelId", _descriptor3, _this);
    _initializerDefineProperty(_this, "cardsCompletedCount", _descriptor4, _this);
    _initializerDefineProperty(_this, "conjugationCardsSeenCount", _descriptor5, _this);
    _initializerDefineProperty(_this, "conjugationDecksFinishedCount", _descriptor6, _this);
    _initializerDefineProperty(_this, "contentReviewCardsCount", _descriptor7, _this);
    _initializerDefineProperty(_this, "contentTreeDecksFinishedCount", _descriptor8, _this);
    _initializerDefineProperty(_this, "grammarTreeDecksFinishedCount", _descriptor9, _this);
    _initializerDefineProperty(_this, "grammarTreeDecksCount", _descriptor10, _this);
    _initializerDefineProperty(_this, "decksCount", _descriptor11, _this);
    _initializerDefineProperty(_this, "finishedUserDecksCount", _descriptor12, _this);
    _initializerDefineProperty(_this, "genderCardsSeenCount", _descriptor13, _this);
    _initializerDefineProperty(_this, "genderDecksFinishedCount", _descriptor14, _this);
    _initializerDefineProperty(_this, "learnedCount", _descriptor15, _this);
    _initializerDefineProperty(_this, "pluralCardsSeenCount", _descriptor16, _this);
    _initializerDefineProperty(_this, "pluralDecksFinishedCount", _descriptor17, _this);
    _initializerDefineProperty(_this, "numberCardsSeenCount", _descriptor18, _this);
    _initializerDefineProperty(_this, "numberDecksFinishedCount", _descriptor19, _this);
    _initializerDefineProperty(_this, "caseCardsSeenCount", _descriptor20, _this);
    _initializerDefineProperty(_this, "retiredCount", _descriptor21, _this);
    _initializerDefineProperty(_this, "reviewCardsCompletedCount", _descriptor22, _this);
    _initializerDefineProperty(_this, "reviewCardsCount", _descriptor23, _this);
    _initializerDefineProperty(_this, "sentenceSubmissionsCount", _descriptor24, _this);
    _initializerDefineProperty(_this, "triviaDecksFinishedCount", _descriptor25, _this);
    _initializerDefineProperty(_this, "triviaQuestionsAnsweredCount", _descriptor26, _this);
    _initializerDefineProperty(_this, "triviaPointsLastWeek", _descriptor27, _this);
    _initializerDefineProperty(_this, "triviaPointsLastMonth", _descriptor28, _this);
    _initializerDefineProperty(_this, "triviaPointsRankingTotal", _descriptor29, _this);
    _initializerDefineProperty(_this, "triviaPointsRankingLastWeek", _descriptor30, _this);
    _initializerDefineProperty(_this, "triviaPointsRankingLastMonth", _descriptor31, _this);
    _initializerDefineProperty(_this, "triviaGamesWon", _descriptor32, _this);
    _initializerDefineProperty(_this, "triviaGamesLost", _descriptor33, _this);
    _initializerDefineProperty(_this, "triviaGamesTied", _descriptor34, _this);
    _initializerDefineProperty(_this, "vocabDecksFinishedCount", _descriptor35, _this);
    _initializerDefineProperty(_this, "vocabReviewCardsCount", _descriptor36, _this);
    _initializerDefineProperty(_this, "vocabTrainerWordsSeenCount", _descriptor37, _this);
    _initializerDefineProperty(_this, "currentMonthXp", _descriptor38, _this);
    _initializerDefineProperty(_this, "currentDayXp", _descriptor39, _this);
    _initializerDefineProperty(_this, "xp", _descriptor40, _this);
    _initializerDefineProperty(_this, "xpLastMonth", _descriptor41, _this);
    _initializerDefineProperty(_this, "xpLastWeek", _descriptor42, _this);
    _initializerDefineProperty(_this, "xpLevel", _descriptor43, _this);
    _initializerDefineProperty(_this, "xpRankingLastMonth", _descriptor44, _this);
    _initializerDefineProperty(_this, "xpRankingLastWeek", _descriptor45, _this);
    _initializerDefineProperty(_this, "xpRankingTotal", _descriptor46, _this);
    _initializerDefineProperty(_this, "triviaQuestionsCount", _descriptor47, _this);
    _initializerDefineProperty(_this, "contentTreeDecksCount", _descriptor48, _this);
    _initializerDefineProperty(_this, "grammarTreeDecksCount", _descriptor49, _this);
    _initializerDefineProperty(_this, "vocabTrainerWordsCount", _descriptor50, _this);
    _initializerDefineProperty(_this, "vocabTrainerNounsCount", _descriptor51, _this);
    _initializerDefineProperty(_this, "vocabTrainerVerbsCount", _descriptor52, _this);
    _initializerDefineProperty(_this, "vocabTrainerPluralsCount", _descriptor53, _this);
    _initializerDefineProperty(_this, "vocabTrainerGendersCount", _descriptor54, _this);
    _initializerDefineProperty(_this, "vocabTrainerNumbersCount", _descriptor55, _this);
    _initializerDefineProperty(_this, "caseTrainerWordAssociationsCount", _descriptor56, _this);
    _initializerDefineProperty(_this, "vocabLevelId", _descriptor57, _this);
    _initializerDefineProperty(_this, "vocabWordTypeId", _descriptor58, _this);
    _initializerDefineProperty(_this, "vocabLearned", _descriptor59, _this);
    _initializerDefineProperty(_this, "vocabReviewing", _descriptor60, _this);
    _initializerDefineProperty(_this, "vocabHasSentence", _descriptor61, _this);
    _initializerDefineProperty(_this, "vocabHasHighlightedVocabTriad", _descriptor62, _this);
    _initializerDefineProperty(_this, "vocabSeen", _descriptor63, _this);
    _initializerDefineProperty(_this, "vocabLanguagesWithWithout", _descriptor64, _this);
    _initializerDefineProperty(_this, "lastVisitedGrammarNodeId", _descriptor65, _this);
    _initializerDefineProperty(_this, "lastActiveTreeNodeId", _descriptor66, _this);
    _initializerDefineProperty(_this, "specialCharacters", _descriptor67, _this);
    _initializerDefineProperty(_this, "level", _descriptor68, _this);
    _initializerDefineProperty(_this, "language", _descriptor69, _this);
    _initializerDefineProperty(_this, "updatedAt", _descriptor70, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor71, _this);
    return _this;
  }
  _inherits(TargetLanguage, _RootModel);
  return _createClass(TargetLanguage, [{
    key: "specialCharacterList",
    get: function get() {
      var _this$specialCharacte;
      return (_this$specialCharacte = this.specialCharacters) === null || _this$specialCharacte === void 0 ? void 0 : _this$specialCharacte.split('');
    }
  }, {
    key: "contentTreeDecksUnfinishedCount",
    get: function get() {
      return this.contentTreeDecksCount - this.contentTreeDecksFinishedCount;
    }
  }, {
    key: "studentGreaterThanA1",
    get: function get() {
      return this.level && this.level.abbreviation !== 'A1' && this.level.abbreviation !== 'N';
    }
  }, {
    key: "xpForNextLevel",
    get: function get() {
      var nextLevel = this.xpLevel + 2;
      return 25 * nextLevel * nextLevel - 25 * nextLevel;
    }
  }, {
    key: "xpForCurrentLevel",
    get: function get() {
      var level = this.xpLevel + 1;
      return 25 * level * level - 25 * level;
    }
  }, {
    key: "xpRangeBetweenLevels",
    get: function get() {
      return this.xpForNextLevel - this.xpForCurrentLevel;
    }
  }, {
    key: "progressOnCurrentLevel",
    get: function get() {
      return this.xp - this.xpForCurrentLevel;
    }
  }, {
    key: "levelAbbreviation",
    get: function get() {
      return this.hasLevel ? this.level.abbreviation || 'N' : null;
    }
  }, {
    key: "hasLevel",
    get: function get() {
      return (0, _utils.isPresent)(this.level) && (0, _utils.isPresent)(this.level.id);
    }
  }, {
    key: "incrementXp",
    value: function incrementXp(amount) {
      if (amount > 0) {
        this.xp += amount;
        this.currentDayXp += amount;
        if (this.xp > this.xpForNextLevel) {
          this.xpLevel += 1;
        }
      }
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "levelId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "cardsCompletedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "conjugationCardsSeenCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "conjugationDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "contentReviewCardsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "contentTreeDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "grammarTreeDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "grammarTreeDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "decksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "finishedUserDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "genderCardsSeenCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "genderDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "learnedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "pluralCardsSeenCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "pluralDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "numberCardsSeenCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "numberDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "caseCardsSeenCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "retiredCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "reviewCardsCompletedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "reviewCardsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "sentenceSubmissionsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "triviaDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "triviaQuestionsAnsweredCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "triviaPointsLastWeek", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "triviaPointsLastMonth", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "triviaPointsRankingTotal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "triviaPointsRankingLastWeek", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "triviaPointsRankingLastMonth", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "triviaGamesWon", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "triviaGamesLost", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "triviaGamesTied", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "vocabDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "vocabReviewCardsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerWordsSeenCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "currentMonthXp", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "currentDayXp", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "xp", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "xpLastMonth", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "xpLastWeek", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "xpLevel", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "xpRankingLastMonth", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "xpRankingLastWeek", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "xpRankingTotal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "triviaQuestionsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "contentTreeDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "grammarTreeDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerWordsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerNounsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerVerbsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerPluralsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerGendersCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerNumbersCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "caseTrainerWordAssociationsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "vocabLevelId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "vocabWordTypeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "vocabLearned", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "vocabReviewing", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "vocabHasSentence", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "vocabHasHighlightedVocabTriad", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "vocabSeen", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "vocabLanguagesWithWithout", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "lastVisitedGrammarNodeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "lastActiveTreeNodeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "specialCharacters", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "level", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "language", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "specialCharacterList", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "specialCharacterList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contentTreeDecksUnfinishedCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contentTreeDecksUnfinishedCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "studentGreaterThanA1", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "studentGreaterThanA1"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "xpForNextLevel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "xpForNextLevel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "xpForCurrentLevel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "xpForCurrentLevel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "xpRangeBetweenLevels", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "xpRangeBetweenLevels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "progressOnCurrentLevel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "progressOnCurrentLevel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "levelAbbreviation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "levelAbbreviation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasLevel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasLevel"), _class.prototype), _class);
var _default = exports["default"] = TargetLanguage;